/*
 * tree-menu.js - add an Assign as default to the option menu
 */
/* jshint esversion: 6 */
'use strict';

jQuery(document).ready(function () {
    Sao.View.Tree.prototype.save_optional = function (store = true, assignAsDefault = false) {
        var fields = {};
        for (const column of this.optionals) {
            fields[column.attributes.name] = !column.get_visible();
        }
        if (store && assignAsDefault) {
            var tree_optional_model = new Sao.Model('ir.ui.view_tree_optional');
            tree_optional_model.execute('set_optional', [
                this.view_id, fields
            ], {});
        }
        Sao.Screen.tree_column_optional[this.view_id] = fields;
    };

    Sao.View.Tree.prototype.optional_menu = function (evt) {
        const assignDefaultCheckboxId = 'assign-as-default-checkbox';
        const self = this;

        const toggle = (event) => {
            const column = event.data;
            const checkbox = jQuery(event.delegateTarget);
            const assignAsDefault = jQuery(`#${assignDefaultCheckboxId}`).prop('checked');

            column.set_visible(checkbox.prop('checked'));

            self.save_optional(true, assignAsDefault);
            self.display();
            for (const row of self.rows) {
                row.update_visible();
            }
        };

        const menu = evt.data;
        menu.empty();

        const assignCheckbox = jQuery('<input/>', {
            type: 'checkbox',
            id: assignDefaultCheckboxId
        });

        assignCheckbox.change(function () {
            const assignAsDefault = jQuery(this).prop('checked');
            self.save_optional(true, assignAsDefault);
        });

        menu.append(jQuery('<li/>', { role: 'presentation' }).append(
            jQuery('<a/>', { role: 'menuitem' }).append(
                jQuery('<label/>', { class: 'checkbox' }).append(
                    assignCheckbox
                ).append(' Assign as default')
            )
        ));

        for (const optional of self.optionals) {
            menu.append(jQuery('<li/>', { role: 'presentation' }).append(
                jQuery('<a/>', { role: 'menuitem' }).append(
                    jQuery('<label/>', { class: 'checkbox' }).append(
                        jQuery('<input/>', {
                            type: 'checkbox',
                            checked: optional.get_visible()
                        }).change(optional, toggle)
                    ).append(' ' + optional.attributes.string)
                )
            ));
        }
    };
});
